import { render, staticRenderFns } from "./ChartsSection.vue?vue&type=template&id=233621cc&scoped=true"
import script from "./ChartsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartsSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChartsSection.vue?vue&type=style&index=0&id=233621cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233621cc",
  null
  
)

export default component.exports